require.ensure(['./index.js'], (require) => {
  require('./index.js');
});



// WEBPACK FOOTER //
// ./site/loader.js